export default "__VITE_ASSET__C85b8Tuf__"